import type { Relationship } from '~/packages/commerce/types/json-api';
import type { PriceTier } from '~/packages/commerce/types/price';

export const ProductCategory = {
    EMPLOYER_PROFILE: 'employer-profile',
    JOB_ADS: 'job-ads',
    TALENT_CONTACTS: 'talent-contacts',
} as const;

export const PRODUCT_CATEGORY_ROUTE_MAPPING = {
    [ProductCategory.JOB_ADS]: 'stelleninserate',
    [ProductCategory.EMPLOYER_PROFILE]: 'arbeitgeberprofil',
    [ProductCategory.TALENT_CONTACTS]: 'talentsuche',
};

export type ProductCategoryType =
    (typeof ProductCategory)[keyof typeof ProductCategory];

export type Product = {
    type: string;
    id: string;
    name: string;
    description: string;
    mainProductVariantId: string;
    variants: Relationship<ProductVariant>;
    features: Relationship<ProductFeature>;
    media: Relationship<Media>;
    performance?: ProductFeature;
    teaserFeatures?: ProductFeature[];
};

export type ProductVariant = {
    type: string;
    id: string;
    description: string;
    name: string;
    productId: string;
    priceTiers: PriceTier[];
    purchasable: Boolean;
    addonPriceTiers: PriceTier[];
    maxQuantity: number;
    features: Relationship<ProductFeature>;
    availableAddons: Relationship<ProductVariant>;
    includedAddons: Relationship<ProductVariant>;
};

export type ProductFeature = {
    group: 'performance' | 'teaser-list' | 'service-price' | 'package-name';
    key: string;
    label: string;
    value: string;
    description: string;
};

export type Media = {
    name: string;
    collection: string;
    file_name: string;
    url: string;
    thumbnail_url: string;
    small_url: string;
    medium_url: string;
    large_url: string;
    alt?: string;
};
